<script lang="ts">
import { defineComponent } from "vue"
import ThemedLoading from "@/components/ThemedLoading.vue"

export default defineComponent({
    name: "Modal",
    components: { ThemedLoading },
    emits: ["close"],
    props: {
        title: { type: String, default: null },
        isLoading: { type: Boolean, default: false },
        closeOnMaskClick: { type: Boolean, default: false },
        noPadding: { type: Boolean, default: false },
    },
    methods: {
        onMaskClick() {
            if (this.closeOnMaskClick) {
                this.closeModal()
            }
        },
        closeModal() {
            this.$emit("close")
        },
        onKeyUp(event: KeyboardEvent) {
            if (event.key === "Escape") {
                this.closeModal()
            }
        },
    },
    mounted() {
        window.addEventListener("keyup", this.onKeyUp)
    },
    beforeDestroy() {
        window.removeEventListener("keyup", this.onKeyUp)
    },
})
</script>

<template>
    <transition name="modal">
        <div class="modal-mask" tabindex="0" @click.self="onMaskClick">
            <div class="modal-wrapper" @click.self="onMaskClick">
                <div class="modal-container">
                    <ThemedLoading
                        :active="isLoading"
                        :is-full-page="false"
                        loader="dots"
                        :opacity="0.6"
                        :can-cancel="false"
                    ></ThemedLoading>
                    <div class="modal-header">
                        <slot name="header">
                            <slot v-if="$slots.title" name="title"></slot>
                            <h4 v-else>{{ title }}</h4>
                            <button type="button" class="btn-close" @click="closeModal">
                                <span class="fa fa-solid fa-times"></span>
                            </button>
                        </slot>
                    </div>

                    <div class="modal-body">
                        <div class="wrapper" :class="{ 'no-padding': noPadding }">
                            <slot name="body"></slot>
                        </div>
                    </div>

                    <div v-if="$slots.footer" class="modal-footer">
                        <slot name="footer"> </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
